module.exports = __webpack_public_path__ + "static/img/AITutorialLeft.56f30091.png";